<template>
    <div class="d-flex flex-column" :style="'height: ' + height + 'px'">

        <div v-if="attachment && attachment.adpStatus" class="adp-strip flex-shrink-0 px-3 py-1">
            <div class="v-flex align-center">
                <v-icon small :color="adpStatusColor" class="mr-1">{{ adpStatusIcon }}</v-icon>
                <span class="body-2">{{ adpStatusLabel }}</span>
                <v-spacer />
                <template v-if="hasConfidenceScore">
                    <span class="body-2 grey--text">{{ $t('inb.adp.confidence') }}: {{ confidencePct }}%</span>
                </template>
            </div>
        </div>

        <div class="lm-border pa-1 flex-grow-1" style="overflow: hidden">
            <c-inbox-assessment
                v-if      = "isAssessment"
                :item     = "attachment"
                :readonly = "readonly"
                class     = "white w-100 h-100"
                @morph    = "onMorph"
                @context  = "onContext"
                @changed  = "onChanged"
                ref       = "message"
            />
            <c-inbox-invoice
                v-if      = "isInvoice"
                :item     = "attachment"
                :readonly = "readonly"
                class     = "white w-100 h-100"
                @morph    = "onMorph"
                @context  = "onContext"
                ref       = "message"
            />
            <c-inbox-incident
                v-if      = "isIncident"
                :item     = "attachment"
                :readonly = "readonly"
                class     = "white w-100 h-100"
                @morph    = "onMorph"
                @context  = "onContext"
                ref       = "message"
            />
            <c-inbox-maintenance
                v-if      = "isMaintenance"
                :item     = "attachment"
                :readonly = "readonly"
                class     = "white w-100 h-100"
                @morph    = "onMorph"
                @context  = "onContext"
                ref       = "message"
            />
            <c-inbox-default
                v-if      = "isDefault"
                :item     = "attachment"
                :readonly = "readonly"
                class     = "white w-100 h-100"
                ref       = "message"
                @morph    = "onMorph"
                @context  = "onContext"
            />
        </div>

    </div>
</template>

<script>

import CInboxAssessment from "@/modules/inb/components/main/details/CInboxAssessment";
import CInboxInvoice from "@/modules/inb/components/main/details/CInboxInvoice";
import CInboxIncident from "@/modules/inb/components/main/details/CInboxIncident";
import CInboxMaintenance from "@/modules/inb/components/main/details/CInboxMaintenance";
import CInboxDefault from "@/modules/inb/components/main/details/CInboxDefault";

export default {
    name: "CInboxDetail",

    components: {
        CInboxDefault,
        CInboxMaintenance,
        CInboxIncident,
        CInboxInvoice,
        CInboxAssessment
    },

    props: {
        attachment: {

        },
        height: {

        },
    },

    data: () => ({
    }),

    computed: {
        imports () {
            return this.data;
        },

        isAssessment () {
            return this.isType(2);
        },

        isInvoice () {
            return this.isType(4);
        },

        isIncident () {
            return this.isType(3);
        },

        isMaintenance () {
            return this.isType(5);
        },

        isDefault () {
            return this.isType(1);
        },

        readonly () {
            if (!this.attachment) {
                return true;
            }

            return this.attachment.incidentId != null || this.attachment.confirmed || this.attachment.ignore || this.attachment.duplicate != null;
        },

        adpStatusIcon () {
            switch (this.attachment && this.attachment.adpStatus) {
                case 'SUCCESS':                  return 'mdi-check-circle';
                case 'ERROR':                    return 'mdi-alert-circle';
                case 'IN_PROGRESS':              return 'mdi-progress-clock';
                case 'INSUFFICIENT_CONFIDENCE':  return 'mdi-help-circle';
                default:                         return 'mdi-help-circle-outline';
            }
        },

        adpStatusColor () {
            switch (this.attachment && this.attachment.adpStatus) {
                case 'SUCCESS':                  return 'success';
                case 'ERROR':                    return 'error';
                case 'IN_PROGRESS':              return 'orange darken-2';
                case 'INSUFFICIENT_CONFIDENCE':  return 'amber darken-2';
                default:                         return 'grey';
            }
        },

        adpStatusLabel () {
            switch (this.attachment && this.attachment.adpStatus) {
                case 'SUCCESS':                  return this.$t('inb.adp.success');
                case 'ERROR':                    return this.$t('inb.adp.error');
                case 'IN_PROGRESS':              return this.$t('inb.adp.in_progress');
                case 'INSUFFICIENT_CONFIDENCE':  return this.$t('inb.adp.insufficient_confidence');
                default:                         return this.attachment ? this.attachment.adpStatus : '';
            }
        },

        hasConfidenceScore () {
            return this.attachment &&
                this.attachment.adpConfidence !== null &&
                this.attachment.adpConfidence !== undefined;
        },

        confidencePct () {
            if (!this.hasConfidenceScore) return 0;
            return Math.round(this.attachment.adpConfidence * 100);
        },

    },

    watch: {
        attachment() {
            console.log("attachmet change", this.attachment)
        }
    },

    methods: {
        save (success) {
            this.$refs.message.onSave(success);
        },

        onMorph (event) {
            this.$emit("morph", event);
        },

        onContext (item) {
            this.$emit("context", item);
        },

        onChanged (item) {
            this.$emit("changed", item);
        },

        isType (type) {
            return this.attachment && this.attachment.dtype === type;
        },
    }
}
</script>

<style scoped>
.adp-strip {
    border: 1px solid #e0e0e0;
    background-color: #fafafa;
    margin-bottom: 4px;
}
</style>